/**
 * Subdivides an array into smaller arrays of a given length
 *
 * Each element of the output array will be consecutive slices of the input
 * array, where each slice has a maximum length equal to the divisor.
 *
 * @param array The array to be subdivided
 * @param divisor Max number of elements in each array
 * @return Array of arrays of the original elements
 */
const subdivide = <T extends any>(array: T[], divisor: number) => {
    const divisions: T[][] = [];
    const sliceCount = Math.ceil(array.length / divisor);
    for (let i = 0; i < sliceCount; i++) {
        divisions.push(Array.prototype.slice.call(
            array,
            i * divisor,
            i * divisor + divisor
        ));
    }
    return divisions;
};

export default subdivide;
